module.exports = __webpack_public_path__ + "static/media/ace6.2c05982c.png";